module.exports = __webpack_public_path__ + "static/media/icon_arrow_white.05d66283.svg";